import { render, staticRenderFns } from "./StudentJoinClassModal.vue?vue&type=template&id=563c7224&"
import script from "./StudentJoinClassModal.vue?vue&type=script&lang=js&"
export * from "./StudentJoinClassModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports